// Hook for POST /projects/:projectId/settings/dashboard/reports

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { axios } from '@/src/lib/axios/axios';

export type CreateDashboardReportPayload = {
  url: string;
  name: string;
};

export type LookerReport = {
  id: string;
  name: string;
  url: string;
  index: number;
};

export type CreateDashboardReportResponse = {
  'looker-reports': LookerReport[];
};

export const DASHBOARD_REPORTS_RQ_KEY = 'DashboardReports';

const createDashboardReport = async (
  projectId: string,
  payload: CreateDashboardReportPayload
): Promise<CreateDashboardReportResponse> => {
  const res = await axios.post(`api/projects/${projectId}/settings/dashboard/reports`, payload);
  return res.data;
};

type UseCreateDashboardReportOptions = {
  config?: UseMutationOptions<CreateDashboardReportResponse, Error, CreateDashboardReportPayload>;
};

export const useCreateDashboardReport = (
  projectId: string,
  options: UseCreateDashboardReportOptions = {}
) => {
  const mutation = useMutation<CreateDashboardReportResponse, Error, CreateDashboardReportPayload>(
    (payload) => createDashboardReport(projectId, payload),
    {
      ...options.config,
    }
  );

  return {
    mutation,
    createDashboardReport: mutation.mutate,
    createDashboardReportAsync: mutation.mutateAsync,
    data: mutation.data,
    error: mutation.error,
    isLoading: mutation.isLoading,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
  };
};
